import { useEffect } from 'react';

import { useFetching } from './useFetching';

export function useFetch(fn, deps = []) {
    const fetching = useFetching(fn, deps);

    useEffect(() => {
        fetching.run();
    }, deps);

    return fetching;
}
